import { comparisonAgents } from '@/mocks/comparisonData';

export default function ComparisonSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Agent Comparison
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            See how CSSBuy compares against other popular shopping agents for spreadsheet-based shopping.
          </p>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[768px]">
            <div className="grid grid-cols-4 gap-4">
              {comparisonAgents.map((agent) => (
                <div
                  key={agent.name}
                  className={`rounded-lg p-5 border ${
                    agent.name === 'CSSBuy'
                      ? 'border-primary-300 bg-primary-50/50'
                      : 'border-background-200 bg-background-50'
                  }`}
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-heading font-bold text-sm ${
                      agent.name === 'CSSBuy'
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {agent.logo}
                    </div>
                    <div>
                      <h4 className="font-heading font-semibold text-foreground-900 text-sm">{agent.name}</h4>
                      <div className="flex items-center gap-1">
                        <span className="text-accent-500 text-xs">{'★'.repeat(Math.floor(agent.rating))}{agent.rating % 1 >= 0.5 ? '½' : ''}</span>
                        <span className="text-xs text-foreground-400">{agent.rating}</span>
                      </div>
                    </div>
                  </div>

                  <p className="text-xs text-primary-600 font-medium mb-3">{agent.bestFor}</p>

                  <div className="space-y-2">
                    <p className="text-xs font-semibold text-foreground-700">Pros</p>
                    <ul className="space-y-1">
                      {agent.pros.map((pro) => (
                        <li key={pro} className="flex items-start gap-1.5 text-xs text-foreground-500">
                          <span className="w-4 h-4 flex items-center justify-center text-primary-500 flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-xs"></i>
                          </span>
                          {pro}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="space-y-2 mt-3">
                    <p className="text-xs font-semibold text-foreground-700">Cons</p>
                    <ul className="space-y-1">
                      {agent.cons.map((con) => (
                        <li key={con} className="flex items-start gap-1.5 text-xs text-foreground-400">
                          <span className="w-4 h-4 flex items-center justify-center text-foreground-300 flex-shrink-0 mt-0.5">
                            <i className="ri-close-line text-xs"></i>
                          </span>
                          {con}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}